import product from './product.js';

/**
 * Order object
 * @param {object} cart cart data object
 * @param {boolean} firstOpen is cookie set?
 * @returns {object} merged sdl object
 */
export default (cart, firstOpen = false) => {
	const orderObject = {
		order: {
			campaignMarker: cart.order.campaignMarker || '',
			paymentMethod: cart.selectedPayment.type || '',
			orderId: cart.order.id,
			products: [],
			revenue: 0, // @todo pricing portal data required
			tax: 0, // @todo pricing portal data required
			total: 0, // @todo pricing portal data required
			currencyCode: 'USD', // Should be hardcoded
			localRevenue: cart.order.price.street.unformatted,
			localTax: cart.order.price.tax.unformatted,
			localTotal: cart.order.price.total.unformatted,
			localCurrencyCode: cart.order.currency,
			platform: cart.theme.name,
			brand: cart.theme.brand,
			pp: cart.theme.provider.pp,
			paymentProvider: '-', // @todo pricing portal data required
			testOrder: cart.order.isTest,
			firstOpen,
			flow: cart.order.flow,
			discount: 0, // @todo pricing portal data required
			localDiscount: cart.order.price.discount.absolute.unformatted,
			coupon: cart.order.campaign ? cart.order.campaign : ''
		},
		event: 'order'
	};
	// Check if product is array and is not empty, than fill order object
	if (Array.isArray(cart.order.products) && cart.order.products.length) {
		cart.order.products.forEach((productData) => {
			orderObject.order.products.push(product(productData, cart.order));
		});
	}
	return orderObject;
};
